import { __extends as p } from "./index11.js";
import { Emitter as f } from "./index23.js";
import { backoff as h } from "./index93.js";
var a = "onRemoveFromFuture", m = (
  /** @class */
  function(o) {
    p(r, o);
    function r(t, e, u) {
      var n = o.call(this) || this;
      return n.future = [], n.maxAttempts = t, n.queue = e, n.seen = u ?? {}, n;
    }
    return r.prototype.push = function() {
      for (var t = this, e = [], u = 0; u < arguments.length; u++)
        e[u] = arguments[u];
      var n = e.map(function(i) {
        var s = t.updateAttempts(i);
        return s > t.maxAttempts || t.includes(i) ? !1 : (t.queue.push(i), !0);
      });
      return this.queue = this.queue.sort(function(i, s) {
        return t.getAttempts(i) - t.getAttempts(s);
      }), n;
    }, r.prototype.pushWithBackoff = function(t) {
      var e = this;
      if (this.getAttempts(t) === 0)
        return this.push(t)[0];
      var u = this.updateAttempts(t);
      if (u > this.maxAttempts || this.includes(t))
        return !1;
      var n = h({ attempt: u - 1 });
      return setTimeout(function() {
        e.queue.push(t), e.future = e.future.filter(function(i) {
          return i.id !== t.id;
        }), e.emit(a);
      }, n), this.future.push(t), !0;
    }, r.prototype.getAttempts = function(t) {
      var e;
      return (e = this.seen[t.id]) !== null && e !== void 0 ? e : 0;
    }, r.prototype.updateAttempts = function(t) {
      return this.seen[t.id] = this.getAttempts(t) + 1, this.getAttempts(t);
    }, r.prototype.includes = function(t) {
      return this.queue.includes(t) || this.future.includes(t) || !!this.queue.find(function(e) {
        return e.id === t.id;
      }) || !!this.future.find(function(e) {
        return e.id === t.id;
      });
    }, r.prototype.pop = function() {
      return this.queue.shift();
    }, Object.defineProperty(r.prototype, "length", {
      get: function() {
        return this.queue.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(r.prototype, "todo", {
      get: function() {
        return this.queue.length + this.future.length;
      },
      enumerable: !1,
      configurable: !0
    }), r;
  }(f)
);
export {
  a as ON_REMOVE_FROM_FUTURE,
  m as PriorityQueue
};
//# sourceMappingURL=index24.js.map
